import React from "react";
import { Card, CardBody } from "reactstrap";

const StatCard = ({ label, value, subtitle, color, icon }) => (
  <Card className="border-0 shadow-sm h-100" style={{ borderLeft: `3px solid ${color}` }}>
    <CardBody className="p-3">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="text-uppercase small fw-semibold text-muted" style={{ letterSpacing: "0.5px" }}>{label}</span>
        <div className="d-flex align-items-center justify-content-center" style={{ width: 36, height: 36, borderRadius: 8, background: `${color}1a` }}>
          <i className={`${icon} fs-5`} style={{ color }} />
        </div>
      </div>
      <h3 className="mb-1 fw-bold">{value}</h3>
      <small className="text-muted">{subtitle}</small>
    </CardBody>
  </Card>
);

const ImportStats = ({ stats }) => (
  <div className="row g-3 mb-3">
    <div className="col-md-3">
      <StatCard label="New" value={stats.new_count || 0}
        subtitle="Not in the system yet" color="#0ab39c" icon="ri-add-circle-line text-success" />
    </div>
    <div className="col-md-3">
      <StatCard label="Modified" value={stats.modified_count || 0}
        subtitle="Will update existing invoices" color="#299cdb" icon="ri-refresh-line text-info" />
    </div>
    <div className="col-md-3">
      <StatCard label="Need Review" value={stats.validation_issues || 0}
        subtitle="Require manual validation" color="#f7b84b" icon="ri-error-warning-line text-warning" />
    </div>
    <div className="col-md-3">
      <StatCard label="Unchanged" value={stats.unchanged_count || 0}
        subtitle="Already imported - skipped" color="#878a99" icon="ri-checkbox-multiple-line" />
    </div>
  </div>
);

export default ImportStats;
